import React from "react";

interface ClickableProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
    onClick: (e: React.MouseEvent<HTMLElement>) => void;
    className?: string;
}

const Clickable = React.forwardRef<HTMLDivElement, ClickableProps>(({children, onClick, className, ...props}, ref) => {
    return <div 
        ref={ref}
        className={`cursor-pointer hover:bg-brand-bg-6 ${className}`} 
        onClick={onClick}
        {...props}
    >
        {children}
    </div>
})

export default Clickable;